import axios from "axios";
import { getDeviceInfo, getGeolocation } from "../../utils/fingerprint";

export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
export const POST_ENTER_CALL = "POST_ENTER_CALL";
export const POST_MESSAGES = "POST_MESSAGES";
export const GET_CONSENT = "GET_CONSENT";
export const SET_CONSENT = "SET_CONSENT";

export const setParticipants = (participants) => {
  return {
    type: SET_PARTICIPANTS,
    payload: participants,
  };
};

export const enterCall = (id) => {
  return async (dispatch) => {
    const deviceInfo = getDeviceInfo();
    const geolocation = await getGeolocation();
    const logData = { ...deviceInfo, ...geolocation };

    dispatch({
      type: POST_ENTER_CALL,
      payload: axios
        .post(`llamada/v1/ingresar?id=${encodeURIComponent(id)}`, logData)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error.response)),
    });
  };
};

export const getConsent = (id, silent = false) => {
  return (dispatch) =>
    dispatch({
      type: GET_CONSENT,
      payload: axios
        .get(`llamada/v1/consentimiento?id=${encodeURIComponent(id)}`)
        .then((response) => response.data)
        .catch((error) => (silent ? null : Promise.reject(error.response))),
    });
};

export const setConsent = (id, consentAccepted) => {
  return (dispatch) =>
    dispatch({
      type: SET_CONSENT,
      meta: { consentAccepted },
      payload: axios
        .put(`llamada/v1/Consentimiento?id=${encodeURIComponent(id)}`, {
          consentimientoAceptado: consentAccepted,
        })
        .then((response) => response.data)
        .catch((error) => Promise.reject(error.response)),
    });
};

export const saveChat = (mensajesWithIdSala) => {
  return (dispatch) => {
    dispatch({
      type: POST_MESSAGES,
      payload: axios
        .post(`sala/v1/guardarChat`, mensajesWithIdSala)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error.response)),
    });
  };
};
